module.exports = __webpack_public_path__ + "img/icon-next-circle.22ae0914.svg";